import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { data } from "../data";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import { trustimg, trustimg2, trustimg3, trustimg4 } from "../../../assets/img";
import {
  fetchHomeJsonList,
  saveThemeJsonData,
  fetchCroppedImage,
} from "../../../redux/Actions";
import { ColorPicker } from "primereact/colorpicker";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
import ImageCropper from "../../imageCropper/imageCropper";

function SectionFourThemeFourEdit() {
  const [checklist, setChecklist] = useState<any>([
    { id: 1, title: "" }, // Initial empty checklist item
  ]);
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>();
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState("");
  const [cropImageWidth, setCropImageWidth] = useState("");
  const [selectedCropImage, setSelectedCropImage] = useState("");
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>("" || undefined);
  const banner = [
    "assets/home/cateimg1.jpg",
    "assets/home/cateimg2.jpg",
    "assets/home/cateimg3.jpg",
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg2.jpg",
    "assets/home/cateimg1.jpg",
    "assets/home/cateimg2.jpg",
    "assets/home/cateimg3.jpg",
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg2.jpg",
  ];

  const saveJsonDataToFile = () => {
    dispatch(fetchHomeJsonList(editData));
    dispatch(saveThemeJsonData(editData));
  };
  const handleSection2Change = (e: any) => {
    const { value, name, type, checked } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        home: {
          ...prevJsonData.theme_4.home,
          section_4: {
            ...prevJsonData.theme_4.home.section_4,
            [name]: value,
            btn_group: {
              ...prevJsonData.theme_4.home.section_4.btn_group,
              btn1: {
                ...prevJsonData.theme_4.home.section_4.btn_group.btn1,
                [name]: value,
              },
            },
          },
        },
      },
    }));
    // saveJsonDataToFile();
  };
  const handleImageChange = (image: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        home: {
          ...prevJsonData.theme_4.home,
          section_4: {
            ...prevJsonData.theme_4.home.section_4,
            banner: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  useEffect(() => {
    const checklistData = editData?.theme_4?.home?.section_4?.check_list;
    if (checklistData) {
      setChecklist(checklistData);
    }
  }, [editData]);
  useEffect(() => {
    setEditData(jsonData);
  }, [jsonData]);
  useEffect(() => {
    if (editData != undefined) {
      // dispatch(fetchHomeJsonList(editData));
      setEditData(editData);
    }
  }, [editData]);
  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section 4 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                    <label className="form-label">Title</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={editData?.theme_4?.home?.section_4?.title}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                    </div>
                    </div>
              </div>
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                      <label className="form-label">Paragraph One</label>
                      <input
                        type="text"
                        className="form-control"
                        name="paragraph_one"
                        value={
                          editData?.theme_4?.home?.section_4?.paragraph_one
                        }
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                      <label className="form-label">Paragraph Two</label>
                      <input
                        type="text"
                        className="form-control"
                        name="paragraph_two"
                        value={
                          editData?.theme_4?.home?.section_4?.paragraph_two
                        }
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={
                          editData?.theme_4?.home?.section_4?.h2color
                        }
                        onChange={handleSection2Change}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleSection2Change}
                        value={
                          editData?.theme_4?.home?.section_4?.h2color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={
                          editData?.theme_4?.home?.section_4?.paracolor
                        }
                        onChange={handleSection2Change}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleSection2Change}
                        value={
                          editData?.theme_4?.home?.section_4?.paracolor
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        name="image"
                        onChange={updateImageSectionOne}
                      />
                    </div>
                </div>
              </div>
            </div>
                    <div className="edit-section">
                      <div className="row">
                        <div className="col">
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-md-12">
                                {/* {editData?.theme_4?.home?.section_4?.banner?.map(
                                  (card: any, index: any) => (
                                    <> */}
                                <div className="img-bg active">
                                  <img
                                    src={
                                      editData?.theme_4?.home?.section_4?.banner
                                    }
                                    alt={`Card Icon`}
                                  />
                                </div>
                                <div className="img-options w-100">
                                  <Swiper
                                    spaceBetween={15}
                                    navigation={true}
                                    modules={[Navigation]}
                                    breakpoints={{
                                      640: {
                                        slidesPerView: 1,
                                      },
                                      768: {
                                        slidesPerView: 4,
                                      },
                                      1024: {
                                        slidesPerView: 6,
                                      },
                                    }}
                                    className="homejson-slider"
                                  >
                                    {banner.map((icons, iconIndex) => (
                                      <SwiperSlide key={iconIndex}>
                                        <div
                                          className="img-option"
                                          onClick={() =>
                                            handleImageChange(icons)
                                          }
                                        >
                                          <img
                                            src={icons}
                                            alt="Hero Image"
                                            className="img-fluid"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    ))}
                                  </Swiper>
                                </div>
                                {/* </>
                                  )
                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button 1</label>
                    <input
                      type="text"
                      className="form-control"
                      name="text"
                      value={
                        editData?.theme_4?.home?.section_4?.btn_group?.btn1
                          ?.text
                      }
                      onChange={handleSection2Change}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Bg Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="bg_color"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.bg_color
                        }
                        style={{
                          background: `#${editData?.theme_4?.home?.section_4?.btn_group?.btn1?.bg_color}`,
                        }}
                        onChange={handleSection2Change}
                        maxLength={250}
                      />
                      <ColorPicker
                        name="bg_color"
                        onChange={(e) => {
                          handleSection2Change(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="color"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.color
                        }
                        style={{
                          background: `${editData?.theme_4?.home?.section_4?.btn_group?.btn1?.color}`,
                        }}
                        onChange={handleSection2Change}
                      />
                      <ColorPicker
                        name="color"
                        onChange={(e) => {
                          handleSection2Change(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Option One</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="option_one"
                        value={editData?.theme_4?.home?.section_4?.option_one}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Option Two</label>
                      <input
                        type="text"
                        className="form-control"
                        name="option_two"
                        value={editData?.theme_4?.home?.section_4?.option_two}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Option Three</label>
                      <input
                        type="text"
                        className="form-control"
                        name="option_three"
                        value={editData?.theme_4?.home?.section_4?.option_three}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonDataToFile();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: "block" }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
}

export default SectionFourThemeFourEdit;
